
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAddHomeOfficeGroups (
    GroupListService, $timeout, $http, $q, $filter, toastr,
    GroupListPOSTPaging, GroupFilterModel, $rootScope, Utils,
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        prepModifyGroups: '=modifyGroups',
        exclude: '=exclude',
        tenant: "=tenant",
        dialogMode: "=mode",
        closeDialog: '&closeDialog',
        selection: '&selection',
      },
      templateUrl: 'app/components/settings/homeOffice/addHomeOfficeGroups/addHomeOfficeGroups.template.html',
      link: function(scope) {

        scope.modifyGroups = angular.copy(scope.prepModifyGroups) || [];
        scope.groupListPaging = new GroupListPOSTPaging();
        scope.groupList = [];
        scope.noGroupSelected = true;
        scope.ALLOW_UPDATE = false;
        scope.ALLOW_REMOVE = false;
        scope.ALLOW_MODIFY = false;
        var scrollEnd = null;
        var containerHeight = null;
        scope.step = 'SELECT';
        scope.updating = false;

        scope.steps = {
          SELECT: 'SELECT',
          MANAGE: 'MANAGE',
          UPDATE: 'UPDATE'
        }

        scope.inconsistencyDetected = false;
        var pageSections = {};

        scope.groupSettingsModel = {
          exclusiveAccess: false,
          autoInstall: false,
          defaultForGroup: false,
        };

        scope.groupSettingsMiddleStage = {
          exclusiveAccess: false,
          autoInstall: false,
          defaultForGroup: false,
        };

        scope.groupRemoveModel = {
          accept: false
        };

        scope.UPDATING = false;
        scope.FAILED = false;

        scope.searchString = '';
        scope.search = {string: ''};
        scope.groupsLoaded = 0;
        scope.groupsTotal = 0;
        scope.selectedGroups = [];
        const excludedGrups = scope.exclude.map(group => group.info._links.self.href) || [];

        if (scope.dialogMode === 'ADD_GROUPS') {
          scope.groupListPaging.pagingCriteria.exclude = excludedGrups;
          $timeout(()=>{
            angular.element('.add-group-dialog').on('scroll', function (event) {
              scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
              containerHeight = event.currentTarget.scrollHeight;

              if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
                if (scrollEnd > containerHeight) {
                  $timeout(function() {
                    getNextGroupsPage();
                  }, 300)
                }
              }
            });
          },300)
        }

        (function() {
          // Maybe apply filters preset
          scope.presetFilters = [{
            name: 'Groups',
            parameter: 'inUse',
            key: 'inUse',
            type: 'radio',
            value: 'PrintixAssignedGroups',
            state: true
          }]

          scope.filtersList = new GroupFilterModel('GROUPS').filters;
        })();

        scope.getFirstGroupsPage = function () {
          getFirstGroupsPage();
        }

        function excludeGroups () {
          scope.groupListPaging.pagingCriteria.exclude = [];
          scope.groupListPaging.pagingCriteria.exclude = excludedGrups;
          scope.groupListPaging.pagingCriteria.exclude = scope.groupListPaging.pagingCriteria.exclude.concat(scope.selectedGroups.map(group => group.info._links.self.href))
        }

        function getFirstGroupsPage() {
          excludeGroups();
          scope.groupListPaging.pagingCriteria.page = 0;
          scope.loadingPage = true;
          scope.groupList = [];
          pageSections = {};

          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function (response) {
            angular.element('.add-group-dialog').scrollTop(0);
            pageSections[response.page.number] = response
            scope.totalPages = response.page.totalPages;
            scope.groupList = response.list;
            scope.loadingPage = false;
            scope.groupsTotal = response.page.totalElements
            scope.groupsLoaded = scope.groupList.length;
          }).catch(function(error) {});
        }

        scope.textSearch = function () {
          scope.groupListPaging.pagingCriteria.match = scope.search.string;
          angular.element('.add-group-dialog').scrollTop(0);
          getFirstGroupsPage();
        }


        function getNextGroupsPage () {
          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.groupListPaging.pagingCriteria.page += 1;
            GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){
              pageSections[response.page.number] = response
              if (response.list) {
                scope.groupList = scope.groupList.concat(response.list);
              }
              scope.loadingPage = false;
              scope.groupsTotal = response.page.totalElements
              scope.groupsLoaded = scope.groupList.length;
            }).catch(function(error) {});
          }
        }

        function getThisPageSection (pageSection) {
          var pageSectionsKeys = Object.keys(pageSections).length -1;
          excludeGroups();

          scope.groupListPaging.pagingCriteria.page = pageSection
          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){

            if (pageSection < pageSectionsKeys) {
              pageSections[pageSection] = response
              getThisPageSection(pageSection += 1)
            } else {
              var pageSectionList = []
              pageSections[pageSection] = response

              for(var key in pageSections) {
                pageSectionList = pageSectionList.concat(pageSections[key].list)
              }

              scope.groupList = pageSectionList
              scope.loadingPage = false;
              scope.groupsTotal = response.page.totalElements
              scope.groupsLoaded = scope.groupList.length;
            }
          }).catch(function(error) {})
        }

        scope.addLoadedGroups = function () {
          scope.loadingPage = true;
          scope.groupList.forEach((group) => {
            for (var key in scope.groupSettingsModel) {
              group[key] = scope.groupSettingsModel[key]
            }
          })

          scope.selectedGroups = scope.selectedGroups.concat(scope.groupList)
          scope.selectedGroups = scope.selectedGroups.slice().sort((a, b) => a.info.name.localeCompare(b.info.name));
          getFirstGroupsPage()
          validateForm()
        }

        scope.removeSelectedGroups = function () {
          scope.loadingPage = true;
          scope.selectedGroups = []
          getFirstGroupsPage()
          validateForm()
        }

        scope.addGroup = function (group, index) {
          scope.loadingPage = true;

          scope.selectedGroups.push(group);
          scope.selectedGroups = scope.selectedGroups.slice().sort((a, b) => a.info.name.localeCompare(b.info.name));

          getThisPageSection(getSectionFromItemIndex(index));
          validateForm()
        }

        function getSectionFromItemIndex(index) {
          return Math.floor(index / 20);
        }

        scope.removeGroup = function (group) {
          scope.loadingPage = true;
          scope.selectedGroups = scope.selectedGroups
            .filter(filteredGroup => filteredGroup !== group)
            .sort((a, b) => a.info.name.localeCompare(b.info.name));
          var index = findInsertionIndex(group.info.name);
          getThisPageSection(getSectionFromItemIndex(index));
          validateForm()
        }

        scope.removeModifyGroup = function (group) {
          scope.modifyGroups = scope.modifyGroups
            .filter(filteredGroup => filteredGroup !== group)
            .sort((a, b) => a.info.name.localeCompare(b.info.name));
            validateRemoveForm()
        }


        function validateForm () {
          scope.ALLOW_UPDATE = scope.selectedGroups.length || false;
        }


        function validateRemoveForm () {
          if (scope.modifyGroups.length && scope.groupRemoveModel.accept) {
            scope.ALLOW_REMOVE = true;
          } else {
            scope.ALLOW_REMOVE = false;
          }
        }

        function findInsertionIndex(name) {
          let left = 0;
          let right = scope.groupList.length - 1;

          while (left <= right) {
            const middle = Math.floor((left + right) / 2);
            const middleItemName = scope.groupList[middle].info.name;

            if (middleItemName === name) {
              return middle;
            }

            if (name < middleItemName) {
              right = middle - 1;
            } else {
              left = middle + 1;
            }
          }

          return left;
        }

        scope.resetDialog = function () {
          scope.loadingPage = true;
          scope.selectedGroups = [];

          $timeout(()=> {
            getFirstGroupsPage();
          }, 1100)
          validateForm()
        }

        scope.next = function (step) {
          scope.step = step
          switch (step) {
            case 'ADD_GROUPS':
              POST_GROUPS();
            break;
            case 'REMOVE_GROUPS':
              DELETE_GROUPS('modifyGroups');
            break;
            case 'CLOSE':
              scope.closeDialog({state: 'EXIT'});
            break;
          }
        }

        scope.toggleRemove = function () {
          validateRemoveForm()
        }

        function POST_GROUPS() {
          var url = scope.context.endpoint;
          var requestBody = {
            groups: scope.selectedGroups.map(group => group.info._links.self.href)
          };

          $http.post(url, requestBody).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
            $rootScope.$broadcast('UPDATE_HOME_OFFICE_GROUPS')
          }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"));
          });
          scope.closeDialog();
        }

        function DELETE_GROUPS() {
          var url = scope.context.endpoint;
          var requestBody = {
            groups: scope.modifyGroups.map(group => group.info._links.self.href)
          };


          $http.delete(url, {headers: {"Content-Type": "application/json"}, data: requestBody}).then(function(response) {
            $rootScope.$broadcast('UPDATE_HOME_OFFICE_GROUPS')
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"));
          });
          scope.closeDialog();
        }

        function callback (type) {
          $timeout(() => {
            if (type === 'success') {
              toastr.success($filter('translate')('ChangesSaved'))
            }

            $rootScope.$broadcast('PRINT_QUEUE_GROUPS_UPDATE_CALLBACK')
          }, 800)

        }


        scope.close = function () {
          scope.closeDialog({state: 'EXIT'});
        }

        scope.$on('$destroy', function() {
          angular.element('.add-group-dialog').off('scroll');
          // customKeyBinding = false;
        });



      }
    };
  }

  pxAddHomeOfficeGroups.$inject = [
    'GroupListService', '$timeout', '$http', '$q', '$filter', 'toastr',
    'GroupListPOSTPaging', 'GroupFilterModel', '$rootScope', 'Utils'
  ];

  angular
    .module('printix-admin')
    .directive('pxAddHomeOfficeGroups', pxAddHomeOfficeGroups);

})();

